export enum GridCompatibilityProcessStatus {
  RequestSent = 1,
  RequestUpdated,
  OpenIssue,
  FeedInPermissionIssued,
  FeedInPermissionExpired,
  ExtensionOfFeedInPermissionRequested,
  RequestDenied,
  RequestWithdrawn,
}
